"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvatarData = getAvatarData;
function getAvatarData(users, maxUsersUntilOverflow) {
  let visibleUsers = [];
  let overflowUsers = [];
  if (users.length <= maxUsersUntilOverflow) {
    visibleUsers = users;
    overflowUsers = [];
  } else {
    const displayableUsersWithOverflow = maxUsersUntilOverflow - 1;
    visibleUsers = users.slice(0, displayableUsersWithOverflow);
    overflowUsers = users.slice(displayableUsersWithOverflow);
  }
  return {
    visibleUsers,
    overflowUsers
  };
}
//# sourceMappingURL=getAvatarData.js.map